import './App.css'

import Alert from './component/Alert'
import ExpenseForm from './component/ExpenseForm'
import ExpenseList from './component/ExpenseList'
import React, { useState, useEffect } from 'react'
import uuid from 'react-uuid'

// const initialExpense = [
// { id: uuid(), charge: 'rent', mount: 1600 },
// { id: uuid(), charge: 'car payment', mount: 400 },
// { id: uuid(), charge: 'credi card build', mount: 1200 }
// ]
const initialExpense = localStorage.getItem('expenses')
  ? JSON.parse(localStorage.getItem('expenses'))
  : []

function App () {
  //************* state value************/
  // all expense add expense
  const [expenses, setExpenses] = useState(initialExpense)
  // single  expense
  const [charge, setCharge] = useState('')
  // single  amount
  const [mount, setMount] = useState('')
  //alert
  const [alert, setAlert] = useState({ show: false })
  // editt
  const [edit, setEdit] = useState(false)
  const [id, setId] = useState(0)

  useEffect(() => {
    console.log('locale storagr')
    localStorage.setItem('expenses', JSON.stringify(expenses))
  })
  //********* functionality*********************8888888 */
  const handleCharge = e => {
    setCharge(e.target.value)
  }
  const handleAmount = e => {
    setMount(e.target.value)
  }
  const handleAlert = ({ type, text }) => {
    setAlert({ show: true, type, text })
    setTimeout(() => {
      setAlert({ show: false })
    }, 3000)
  }
  // clear all items
  const clearItems = () => {
    setExpenses([])
    handleAlert({ type: 'danger', text: 'all item is cleared' })
  }
  //handle Delete items
  const handleDelete = id => {
    let tempExpense = expenses.filter(item => item.id != id)
    console.log(tempExpense)
    setExpenses(tempExpense)
    handleAlert({ type: 'danger', text: 'items id deleted' })
  }
  //handle Edit items
  const handleEdit = id => {
    let expense = expenses.find(item => item.id === id)
    let { charge, mount } = expense
    setCharge(charge)
    setMount(mount)
    setEdit(true)
    setId(id)

    console.log(expense)
  }

  const handleSubmit = e => {
    e.preventDefault()

    if (charge !== '' && mount > 0) {
      if (edit) {
        let tmpExpenses = expenses.map(item => {
          return item.id == id ? { ...item, charge, mount } : item
        })
        setExpenses(tmpExpenses)
        setId(false)
        handleAlert({ type: 'success', text: 'item edited' })
      } else {
        const singleExpense = { id: uuid(), charge, mount }
        setExpenses([...expenses, singleExpense])
        handleAlert({ type: 'success', text: 'item added' })
      }

      setCharge('')
      setMount('')
    } else {
      handleAlert({
        type: 'danger',
        text: "charge can't be empty value and amount  should bigger than zero"
      })
    }
  }
  return (
    <>
      {alert.show && <Alert type={alert.type} text={alert.text} />}
      <h1>budget calculator</h1>
      <main className='App'>
        <ExpenseForm
          charge={charge}
          mount={mount}
          handleCharge={handleCharge}
          handleAmount={handleAmount}
          handleSubmit={handleSubmit}
          edit={edit}
          handleEdit={handleEdit}
        />
        <ExpenseList
          expenses={expenses}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          clearItems={clearItems}
        />
      </main>
      <h1>
        Total Spending :{' '}
        <span className='total'>
          ${' '}
          {expenses.reduce((acc, curr) => {
            return (acc += parseInt(curr.mount))
          }, 0)}
        </span>
      </h1>
    </>
  )
}

export default App
